import { useCallback, startTransition } from "react";

const useWsCommonMessageHandlers = ({
  setIsSessionReady,
  setError,
  setArchiveId,
  setMessages,
  setClawPasswordDialogOpen,
  setClawPasswordError,
  setClawPasswordLoading,
  setCCDeviceSelectorOpen,
  setCCSelectedDevice,
  setYTSelectedDevice,
  setYTSessionState,
  setYTDevicePasswordError,
  showNotification,
  setArchivesList,
}) => {
  const handleWsCommonMessage = useCallback((data) => {
    if (data.type === "session_ready") {
      console.log("会话准备完成:", data.message, "session_id:", data.session_id);
      setIsSessionReady(true);
      return true;
    }

    if (data.type === "session_creation_failed") {
      console.error("会话创建失败:", data.error, data.details);
      setError({ message: `会话创建失败：${data.details || data.error}` });
      return true;
    }

    if (data.type === "current_archive_id_response") {
      console.log("onmessage Received archiveId:", data.archive_id);
      startTransition(() => {
        setArchiveId(data.archive_id);
      });
      return true;
    }

    if (data.type === "expert_recommendations") {
      console.log("收到专家推荐:", data.recommendations);
      setMessages((prev) => [
        ...prev,
        {
          type: "expert_recommendations",
          content: JSON.parse(data.recommendations),
          timestamp: new Date().toISOString(),
          isNew: true,
        },
      ]);
      return true;
    }

    if (data.type === "claw_need_password") {
      console.log("[Claw] 需要输入实验机接入密码");
      if (setClawPasswordDialogOpen) setClawPasswordDialogOpen(true);
      return true;
    }

    if (data.type === "claw_password_error") {
      console.warn("[Claw] 密码验证失败:", data.message);
      if (setClawPasswordLoading) setClawPasswordLoading(false);
      if (setClawPasswordError) setClawPasswordError(data.message || "密码错误，请重新输入");
      if (setClawPasswordDialogOpen) setClawPasswordDialogOpen(true);
      return true;
    }

    if (data.type === "claw_password_ok") {
      console.log("[Claw] 密码验证成功");
      if (setClawPasswordLoading) setClawPasswordLoading(false);
      if (setClawPasswordDialogOpen) setClawPasswordDialogOpen(false);
      if (showNotification) showNotification("实验机接入成功", "success");
      return true;
    }

    if (data.type === "claw_device_offline") {
      console.warn("[Claw] 设备离线:", data.device_id, data.message);
      if (showNotification) showNotification(data.message || "实验机已离线", "warning");
      return true;
    }

    if (data.type === "cc_device_password_error") {
      console.warn("[YouLabber] 实验员访问密码错误:", data.message);
      if (showNotification) showNotification(data.message || "访问密码错误，请重新输入", "warning");
      if (data.source === "youlaber") {
        if (setYTSelectedDevice) setYTSelectedDevice(null);
        if (setYTSessionState) setYTSessionState("idle");
        if (setYTDevicePasswordError) setYTDevicePasswordError(data.message || "访问密码错误，请重新输入");
      } else {
        if (setCCSelectedDevice) setCCSelectedDevice(null);
        if (setCCDeviceSelectorOpen) setCCDeviceSelectorOpen(true);
      }
      return true;
    }

    if (data.type === "cc_need_device_selection") {
      // source="youlaber" 路径由 YouLaberPanel 自己负责选择 UI，
      // 不打开综合训练侧的全局选择弹窗，避免视觉冲突。
      if (data.source === "youlaber") return true;
      console.log("[YouLabber] 需要选择 YouLabber 实验员");
      if (data.error && showNotification) showNotification(data.error, "warning");
      if (setCCDeviceSelectorOpen) setCCDeviceSelectorOpen(true);
      return true;
    }

    if (data.type === "cc_device_selected") {
      console.log("[CC] 设备已选择:", data.device_id, data.device_name);
      const selectedDevice = {
        device_id: data.device_id,
        device_name: data.device_name,
        device_type: data.device_type || "cc-bridge",
      };
      if (data.source === "youlaber") {
        if (setYTSelectedDevice) setYTSelectedDevice(selectedDevice);
        if (setYTDevicePasswordError) setYTDevicePasswordError("");
      } else if (setCCSelectedDevice) {
        setCCSelectedDevice(selectedDevice);
      }
      if (showNotification) showNotification(data.message || "已接入 YouLabber 实验员", "success");
      return true;
    }

    if (data.type === "project_name_updated") {
      if (setArchivesList) {
        startTransition(() => {
          setArchivesList((prevList) =>
            prevList.map((archive) =>
              archive.archiveId === data.archive_id
                ? { ...archive, projectName: data.project_name }
                : archive
            )
          );
        });
      }
      return true;
    }

    return false;
  }, [setArchiveId, setArchivesList, setCCDeviceSelectorOpen, setCCSelectedDevice, setClawPasswordDialogOpen, setError, setIsSessionReady, setMessages, setYTDevicePasswordError, setYTSelectedDevice, setYTSessionState, showNotification]);

  return handleWsCommonMessage;
};

export default useWsCommonMessageHandlers;
